import { Component } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

export class PageErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidUpdate(previous) {
    if (previous.resetKey !== this.props.resetKey && this.state.failed) this.setState({ failed: false });
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div role="alert" className="p-8 space-y-3">
      <h2 className="font-semibold">This page could not be displayed</h2>
      <p className="text-sm text-muted-foreground">Try opening the page again. You can also choose another page from the navigation.</p>
      <Button onClick={() => this.setState({ failed: false })}>Try again</Button>
    </div>;
  }
}

export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  return <PageErrorBoundary resetKey={`${location.pathname}${location.search}`}>{children}</PageErrorBoundary>;
}
